import DeviceDataView from "../views/DeviceDataView.vue";

export const DeviceDataRouters = [
    {
        path: "/deviceData/:clientOs",
        name: "DeviceDataView",
        components: {
            default: DeviceDataView,
        },
        props: {
            default: true
        },
    },
];

